import Vue from 'vue'
import App from './App.vue'
import NewPost from './components/NewPost.vue'
import Home from './components/Home.vue'
import VueRouter from 'vue-router'

Vue.config.productionTip = false

Vue.use(VueRouter)

const routes = [
  { path: '/', component: Home },
  { path: '/new-post', component: NewPost },
]

const router = new VueRouter({
  routes,
  mode: "history"
})

new Vue({
  render: h => h(App),
  router
}).$mount('#app')
